<script lang="ts">
  import { Layout } from "../../components"
  import { Form, TextField, Button, Checkbox } from "@gl/design-system"
  import { _ } from "svelte-i18n"
  import {  createCompositor, getChannel, getCompositor, patchCompositor } from "../../services/endpoints"
  import type { Compositor } from "../../services/models"
  import { navigateCustom } from "../../utils/navigateCustom"
  import { onMount } from "svelte"

  export let uuid: string | null = null;

  let form: Compositor = {
    url: "",
    active: true,
    healthy: true,
    maxJobs: 10,
    runningJobs: 0,
    prioritization: 1,
    healthCheck: "/health/ready",
    apiFilesDownload: "files/download",
    apiPrefix: "/api/v1/",
    apiMediastoreMakeCut: "configs/default/media-stores/make-cut",
    apiMediastoreInfo: "configs/default/media-stores/recorder/metadata",
    mediastoreExportPath: "/mnt/media-library",
    policies: "mediastore-cut_write,mediastore-cut_read,mediastore-cut_create,files_read"
  }

  function create() {
    createCompositor(form).then(compositor => navigateCustom("/compositors/" + compositor.uuid))
  }

  function update() {
    patchCompositor(uuid, form).then(compositor => navigateCustom("/compositors/" + compositor.uuid))
  }

  onMount(() => {
    if(uuid) {
      getCompositor(uuid).then(channel => {
        form = channel
      })
    }
  })
</script>

<Layout selected="compositors">
  <Form>
    <TextField label="Url" variant="Url" required={true} bind:value={form.url}/>
    <Checkbox label="active" bind:value={form.active}/>
    <Checkbox label="healthy" bind:value={form.healthy}/>
    <TextField label="Max Jobs" variant="Number" bind:value={form.maxJobs}/>
    <TextField label="Running Jobs" variant="Number" bind:value={form.runningJobs}/>
    <TextField label="Prioritization" variant="Number" bind:value={form.prioritization}/>
    <TextField label="apiPrefix" bind:value={form.apiPrefix}/>
    <TextField label="healthCheck" bind:value={form.healthCheck}/>
    <TextField label="apiFilesDownload" bind:value={form.apiFilesDownload}/>
    <TextField label="apiMediastoreMakeCut" bind:value={form.apiMediastoreMakeCut}/>
    <TextField label="apiMediastoreInfo" bind:value={form.apiMediastoreInfo}/>
    <TextField label="mediastoreExportPath" bind:value={form.mediastoreExportPath}/>
    <TextField label="policies" bind:value={form.policies}/>
    {#if uuid}
    <Button on:click={() => update()}>
      {$_("common.update")}
    </Button>
    {:else}
    <Button on:click={() => create()}>
      {$_("common.create")}
    </Button>
    {/if}
  </Form>
</Layout>
